import React, {
  useCallback,
  useState,
  useEffect,
  useLayoutEffect,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import BankFail from "../assets/img/bank_fail.svg";
import bankIcon from "../assets/img/bank_icon.svg";
import cardIcon from "../assets/img/card_icon.svg";

import {
  usePlaidLink,
  PlaidLinkOnSuccess,
  PlaidLinkOnEvent,
  PlaidLinkOnExit,
  PlaidLinkOptions,
} from "react-plaid-link";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import AccountFooter from "../components/AccountFooter";
import CardLinkIcon from "../assets/img/card_link_icon.svg";
import Logofill from "../assets/img/logo.svg";
import $ from "jquery";
import { getUser, getUserEmail, getUserToken } from "../libs/user";
import IphoneIcon from "../assets/img/iPhone-icons.svg";
import AndroidIcon from "../assets/img/and-icns.svg";
import SnackBar from "../components/SnackBar";
import RakutenLogo from "../assets/img/rakutenLogo.svg";
import CreditCard from "../assets/img/credit_card.svg";
import {
  getaddedbank,
  plaidgetlinktoken,
  plaidonsuccess,
} from "../services/plaid";
import {
  Generate_Lead,
  Conversion,
  getUtmCampaign,
  getUtmMedium,
  getUtmSource,
  HQUserBankAdd,
  Plaid_bank_login_success,
  Plaid_bank_selected,
  Plaid_flow_exited,
  Plaid_flow_started,
  Web_Bank_link_completed,
  Web_Bank_link_started,
} from "../libs/events";
import AddCard from "../components/AddCard";
import { getRemoteConfig } from "../libs/utils";
import { REMITTANCE_SIGNUP } from "../config/constants";
import { REMITTANCE_NB_HOME_PATH } from "../constants";

function Plaid() {
  const navigate = useNavigate();
  const authToken = getUserToken();
  const screenType = getUtmSource();
  const [searchParams] = useSearchParams();

  const fingerprint = useSelector((state) => state.fingerprint);
  const { userType } = useSelector((state) => state.auth);

  const auth = useSelector((state) => state.auth);
  const loggedInMail = auth?.user?.data?.user?.email;

  const [token, setToken] = useState(null);
  const [dropdownshowlist, setdropdownshowlist] = useState(false);
  const [bankLinkProcess, setbankLinkProcess] = useState(false);
  const [bankadderror, setbankadderror] = useState(false);
  const [waitforresponse, setwaitforresponse] = useState(false);
  const [pageLoaded, setpageLoaded] = useState(null);
  const [addCard, setAddCard] = useState(false);
  const [method, setMethod] = useState("both");
  const [mailUpdated, setMailUpdated] = useState("");

  const remoteConfig = getRemoteConfig();

  const [bodyHeight, setBodyHeight] = useState();
  const banktype = sessionStorage.getItem("banktype");
  const nextFlow = searchParams.get("next");

  const dropDownListShow = () => {
    document.getElementById("main_place").classList.add("sltext");
    setdropdownshowlist(true);
  };
  const closePopUp = () => {
    setbankLinkProcess(null);
    setbankadderror(false);
  };

  const initAddCard = () => {
    Web_Bank_link_started({
      email: getUserEmail(),
      type: "clo",
    });
    setAddCard(true);
  };

  const fetchUserData = async () => {
    const storedUserData = await getUser();
    const mailUpdated = storedUserData?.user?.email_updated;
    setMailUpdated(mailUpdated);
  };

  useEffect(() => {
    fetchUserData();
    if (authToken) {
      if (!mailUpdated && mailUpdated !== "") {
        navigate("/signup", { replace: true });
      }
    }
  }, [authToken, mailUpdated]);

  useLayoutEffect(() => {
    if (banktype) {
      if (remoteConfig) {
        setMethod(banktype);
        if (banktype === "plaid") {
          setpageLoaded("bank");
        } else if (banktype === "rakuten") {
          setpageLoaded("card");
        }
      }
    } else {
      if (remoteConfig) {
        setMethod(remoteConfig.appConfigData.BANK_LINK_TYPE_WEBSITE);
        if (remoteConfig.appConfigData.BANK_LINK_TYPE_WEBSITE === "plaid") {
          setpageLoaded("bank");
        } else if (
          remoteConfig.appConfigData.BANK_LINK_TYPE_WEBSITE === "rakuten"
        ) {
          setpageLoaded("card");
        }
      }
    }

    // if (screenType === REMITTANCE_SIGNUP) {
    //   setMethod("rakuten");
    //   setpageLoaded("card");
    // }
  }, [remoteConfig, banktype, screenType]);

  useEffect(() => {
    $(function () {
      $("#iPhoneUser").hide();
      $("#androidUser").hide();
      var selectdrop = $("div.mm-dropdown .textfirst");
      let button = document.querySelector(".button");
      var li = $("div.mm-dropdown > ul > li.input-option");
      var inputoption = $("div.mm-dropdown .option");
      var default_option = '<i class="opicns"></i> Select Your Mobile Devce';
      selectdrop.click(function (e) {
        e.stopPropagation();
        li.toggle("fast");
      });
      $(document).click(function () {
        li.hide();
      });

      li.click(function () {
        li.toggle("fast");
        var livalue = $(this).data("value");
        var lihtml = $(this).html();
        selectdrop.html(lihtml);
        inputoption.val(livalue);

        if (livalue === "iPhone") {
          setpageLoaded("bank");
          $("#iPhoneUser").show();
          $("#androidUser").hide();
          $(".textfirst").removeClass("sltext");
        } else if (livalue === "Android") {
          setpageLoaded("card");
          $("#iPhoneUser").hide();
          $("#androidUser").show();
          $(".textfirst").removeClass("sltext");
        } else {
          $("#iPhoneUser").hide();
          $("#androidUser").hide();
          $(".textfirst").removeClass("txtsl");
        }
      });
    });
  }, []);

  useLayoutEffect(() => {
    const headerHeight = $(".header").outerHeight();
    const footerHeight = $(".footer").outerHeight();
    setBodyHeight(
      parseFloat($(window).outerHeight() || 0) -
        (parseFloat(headerHeight || 0) + parseFloat(footerHeight || 0))
    );
  }, []);

  useEffect(() => {
    if (authToken) {
      plaidgetlinktoken(authToken)
        .then((response) => {
          setToken(response.linkToken);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, [authToken]);

  const initBankLink = () => {
    Web_Bank_link_started({
      email: getUserEmail(),
      type: "plaid",
    });
  };

  const bankLinked = (data) => {
    Conversion({
      value: 1.0,
      currency: "USD",
      transaction_id: "",
    });

    getaddedbank(authToken)
      .then((response) => {
        Web_Bank_link_completed({
          web_bank_linked: true,
          no_of_active_banks: response.active_account_count,
          utm_source: getUtmSource(),
          utm_medium: getUtmMedium(),
          utm_campaign: getUtmCampaign(),
          type: "plaid",
          email: getUserEmail(),
        });
        if (userType === "INDIAN") {
          Generate_Lead({
            email: getUserEmail(),
          });
        }

        if (response.user_category === "$3") {
          HQUserBankAdd({
            transaction_id: "",
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onSuccess = useCallback(
    (publicToken, metadata) => {
      if (authToken) {
        plaidonsuccess(
          publicToken,
          authToken,
          fingerprint.data,
          metadata.institution,
          metadata.accounts
        )
          .then((response) => {
            bankLinked(response);
            setwaitforresponse(true);
            if (response.isPending === true) {
              setbankLinkProcess(true);
            }

            if (response.success === true) {
              window.tcWebBridge.saveUserState({ status: "accept" });
              // window.tcWebBridge.sendUserState({ status: "accept" });
            } else {
              window.tcWebBridge.saveUserState({ status: "reject" });
              // window.tcWebBridge.sendUserState({ status: "reject" });
            }

            setwaitforresponse(false);

            const nextPath =
              nextFlow === "r" ? REMITTANCE_NB_HOME_PATH : "/getApp";
            navigate(nextPath, { replace: true });
          })
          .catch(function (error) {
            console.log(error);
            window.tcWebBridge.sendUserState({ status: "reject" });
            if (error.code === "4049") {
              setbankadderror(true);
            }
          });
      }
    },
    [authToken, fingerprint.data]
  );

  const onEvent = useCallback((eventName, metadata) => {
    if (eventName === "OPEN") {
      Plaid_flow_started();
    }

    if (eventName === "EXIT") {
      Plaid_flow_exited({
        bank_name: metadata.institution_name,
        error_code: metadata.exit_status,
        status: metadata.error_code,
        exit_screen: metadata.view_name,
      });
    }

    if (eventName === "SELECT_INSTITUTION") {
      Plaid_bank_selected({
        bank_name: metadata.institution_name,
      });
    }

    if (metadata.view_name === "CONNECTED") {
      Plaid_bank_login_success({
        bank_name: metadata.institution_name,
      });
    }
  }, []);

  const onExit = useCallback((error, metadata) => {
    // console.log(error, metadata);
  }, []);

  const config = {
    token,
    onSuccess,
    onEvent,
    onExit,
  };

  const { open, ready } = usePlaidLink(config);

  return (
    <>
      {waitforresponse === true && (
        //  <!-- Security pop up -->
        <div className="popUpOverlay">
          <div className="popUpInner">
            <div className="popUpBox boxBig  noBorder">
              <div className="loaderBox">
                <div className="circle-loader-wrap">
                  <div className="left-wrap">
                    <div className="loader"></div>
                  </div>
                  <div className="right-wrap">
                    <div className="loader"></div>
                  </div>
                </div>
              </div>
              <div className="popupTxt">
                <p>
                  Securely connecting to your account. This may take up to 30
                  seconds.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {bankadderror === true && (
        //  <!-- Security pop up -->
        <div className="popUpOverlay">
          <div className="popUpInner">
            <div className="popUpBox successBox noBorder">
              {/* <div className="doneBox" style={{ background: "none" }}>
                <img src={BankFail} />
              </div> */}
              <div className="popupTxt">
                <h3>Something Went Wrong</h3>
                <p>Your Bank is already in an active state </p>
              </div>
              <div className="popupBtnSec">
                <button
                  type="submit"
                  style={{
                    padding: "10px 61px",
                    width: "100%",
                    cursor: "pointer",
                  }}
                  className="btn btn-primary popupBtn"
                  onClick={closePopUp}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {bankLinkProcess === true && (
        <div className="popUpOverlay">
          <div className="popUpInner">
            <div className="popUpBox successBox noBorder">
              <div className="doneBox" style={{ background: "none" }}>
                <img src={BankFail} />
              </div>
              <div className="popupTxt">
                <h3>Bank linking is in process</h3>
                <p>
                  Oops,it's taking more time than expected. Please check after
                  logging into the app{" "}
                </p>
              </div>
              <div className="popupBtnSec">
                <button
                  type="submit"
                  style={{
                    padding: "10px 61px",
                    width: "100%",
                    cursor: "pointer",
                  }}
                  className="btn btn-primary popupBtn"
                  onClick={closePopUp}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <SnackBar />
      {/* )} */}
      <div className="header">
        <div className="container">
          <div className="headTop">
            {/* <a href="/" className="logo">
              <img src={Logofill} />
            </a> */}
            <div className="topNav">
              <Link to="#" className="navLink">
                Get Started
              </Link>
              <Link to="#" className="navLink active">
                Complete Registration
              </Link>
              {/* <Link to="#" className="navLink">
                Offers
              </Link> */}
              <Link to="#" className="navLink">
                Get the App
              </Link>
            </div>
            <div className="mobCurrentPage">
              <span className="curntPgNo">2 of 3</span> Account
            </div>
          </div>
        </div>
      </div>
      <div className="containtSec" style={{ minHeight: `${bodyHeight}px` }}>
        <div className="container">
          <div className="acntContntRow">
            <div className="actntCntLeftCol">
              <div className="hedSec">
                <h2>Almost there.</h2>
                <h3>
                  {screenType === REMITTANCE_SIGNUP
                    ? "Link the credit card you spend the most with and maximize your benefits from Abound."
                    : "Link the Bank account or Card you spend with most and get the maximum benefits from Abound."}
                </h3>
                <br />
                {screenType === REMITTANCE_SIGNUP && (
                  <h3>
                    Earn cashback on both online and offline purchases, and
                    enjoy a special rate on remittances with zero fees.
                  </h3>
                )}
              </div>
              {method === "both" && (
                <form className="frmSec sumbitError">
                  <div className="formGroup">
                    <div className="flexRow50ColSel">
                      {/* <label className="iclabel">Your Device</label> */}
                      <div
                        id="phoneType"
                        className="mm-dropdown phoneType frmControl"
                      >
                        <div className="textfirst sltext">Select Method</div>
                        <ul>
                          <li className="input-option" data-value="iPhone">
                            <i className="opicns">
                              <img src={bankIcon} alt="Bank add option" />
                            </i>{" "}
                            Add a bank account
                          </li>
                          <li className="input-option" data-value="Android">
                            <i className="andicns">
                              <img src={cardIcon} alt="Card add option" />
                            </i>{" "}
                            Add an eligible card
                          </li>
                        </ul>
                        {/* <input
                        type="hidden"
                        className="option"
                        name="namesubmit"
                        value=""
                      /> */}
                      </div>
                    </div>
                  </div>
                </form>
              )}
              {method === "plaid" && (
                <form className="frmSec sumbitError">
                  <div className="formGroup">
                    <div className="flexRow50ColSel">
                      {/* <label className="iclabel">Your Device</label> */}
                      <div
                        id="phoneType"
                        className="mm-dropdown phoneType frmControl"
                      >
                        <div className="textfirst remove-dropdown ">
                          <i className="opicns">
                            <img src={bankIcon} alt="Bank add option" />
                          </i>{" "}
                          Add a bank account
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              )}
              {method === "rakuten" && screenType !== REMITTANCE_SIGNUP && (
                <form className="frmSec sumbitError">
                  <div className="formGroup">
                    <div className="flexRow50ColSel">
                      {/* <label className="iclabel">Your Device</label> */}
                      <div
                        id="phoneType"
                        className="mm-dropdown phoneType frmControl"
                      >
                        <div className="textfirst remove-dropdown">
                          <i className="andicns">
                            <img src={cardIcon} alt="Card add option" />
                          </i>{" "}
                          Add an eligible card
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              )}

              {pageLoaded === "bank" && (
                <>
                  <div className="linkSecruty">
                    <p>
                      Linking &amp; Security by <span className="plaid"></span>
                    </p>
                  </div>
                  <div className="actnSec">
                    <button
                      className="btnPrimary btnBlock plaidActiveBtn"
                      onClick={() => {
                        initBankLink();
                        open();
                      }}
                      disabled={!ready}
                    >
                      Continue
                    </button>
                  </div>
                </>
              )}
              {pageLoaded === "card" && (
                <>
                  <div className="linkSecruty">
                    <p className="rakutenLogo">
                      Linking &amp; Security by <img src={RakutenLogo} />
                    </p>
                  </div>
                  <div className="actnSec">
                    <button
                      className="btnPrimary btnBlock plaidActiveBtn btnCommon"
                      onClick={() => initAddCard()}
                    >
                      {screenType === REMITTANCE_SIGNUP ? (
                        <div className="rakutenBtnLabel">
                          <img src={CreditCard} /> Add an Eligible Card
                        </div>
                      ) : (
                        "Continue"
                      )}
                    </button>
                  </div>
                </>
              )}
              {pageLoaded === null && (
                <div className="actnSec">
                  <button
                    type="button"
                    className="btnPrimary btnBlock plaidDisableBtn"
                  >
                    Continue
                  </button>
                </div>
              )}
            </div>
            <div className="actntCntRgtCol">
              <div className="rftActImg">
                <img src="https://staticimages.timesclub.co/Website+images/New+Home+Page/Signup_promo.jpg" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <AccountFooter />

      {addCard && (
        <AddCard open={setAddCard} addCard={addCard} redirectPath="/getApp" />
      )}
    </>
  );
}

export default Plaid;
